import SignUpFormWizzard from "../../../components/sign-up/SignUpFormWizzard";

const SignUpPage = () => {
    return(
        <SignUpFormWizzard />
    )
}

export default SignUpPage;